/**
 * @feature landing-page
 * @description Pure utility functions for the WelcomeBanner component.
 */

const GOOGLE_FINANCE_BASE = 'https://www.google.com/finance/quote';

/** External link to AMZN stock on Google Finance. */
export const STOCK_URL = `${GOOGLE_FINANCE_BASE}/AMZN:NASDAQ`;

/** External link to a USD-based FX pair on Google Finance. */
export const getFxUrl = (target: string): string => `${GOOGLE_FINANCE_BASE}/USD-${target}`;

/** External link to AtoZ content by feed ID. */
export const getAtozContentUrl = (feedId: string): string => `https://atoz.amazon.work/feed/content/${feedId}`;

/** ESPN FIFA World Cup scoreboard URL. */
export const FIFA_ESPN_URL = 'https://www.espn.com/soccer/scoreboard/_/league/FIFA.WORLD';

/** ESPN NFL scoreboard URL. */
export const NFL_ESPN_URL = 'https://www.espn.com/nfl/scoreboard';

/**
 * Maps a weather forecast string to an appropriate emoji icon.
 * Uses daytime flag to distinguish sun vs moon for clear skies.
 */
export const getWeatherIcon = (forecast: string, isDaytime: boolean): string => {
  const f = forecast.toLowerCase();
  if (f.includes('thunder') || f.includes('storm')) return '⛈️';
  if (f.includes('rain') || f.includes('shower') || f.includes('drizzle')) return '🌧️';
  if (f.includes('snow') || f.includes('sleet') || f.includes('ice')) return '🌨️';
  if (f.includes('fog') || f.includes('mist') || f.includes('haze')) return '🌫️';
  if (f.includes('cloudy') || f.includes('overcast')) return '☁️';
  if (f.includes('partly') || f.includes('mostly clear')) return isDaytime ? '🌤️' : '☁️';
  if (f.includes('clear') || f.includes('sunny')) return isDaytime ? '☀️' : '🌙';
  return '🌤️';
};
